export default __webpack_public_path__ + "static/media/tickets-white.d5c6cb72.svg";